<template>
  <div class="flex items-center p-1 gap-1 bg-white rounded-[10px] border-black border-solid border-[1px]">
    <button @click="open = !open">
      <img src="~assets/icon/search.svg"
           class="h-[24px]"
           :alt="$t('accessibility.search_icon')"
      />
    </button>
    <div v-if="open" class="relative w-[400px]">
      <AddressSearch ref="addressSearchInput" :address-string-model="addressString"
                     :abort-address-input="abortAddressInput"
                     :select-address="selectAddressFromInput"/>
    </div>
    <button v-if="open" @click="open = false">
      <img src="~assets/icon/close.svg"
           class="h-[24px]"
           :alt="$t('accessibility.close')"
      />
    </button>
  </div>
</template>
<script setup lang="ts">

const props = defineProps<{
  gotoAddress: (lat: number, lon: number) => void
}>();

const open = ref(false);
const addressString = ref<string>("");

const abortAddressInput = () => {
  setTimeout(() => {
    open.value = false;
    addressString.value = "";
  }, 100);
};

const selectAddressFromInput = (address: Address | undefined) => {
  if (address) {
    open.value = false;
    props.gotoAddress(address.lat, address.lon);
    addressString.value = "";
  }
};

</script>